module.exports = __webpack_public_path__ + "static/select4-b230c7b7f12738af88ad3a6c70ddfaa8.png";